export default __webpack_public_path__ + "static/media/lego-sponsor-logo.da8b0e8e.png";